module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai773-9c9c3a118c5bcb71aec36bc5d72bf7d5.jpg";